"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StyledLink = (0, _styles.styled)('a')(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.font.tertiary,
    textDecoration: 'none'
  };
});
var StyledGrid = (0, _styles.styled)(_material.Grid)(function (_ref2) {
  var _ref3;

  var theme = _ref2.theme;
  return _ref3 = {
    flexWrap: 'nowrap',
    '&': {
      '--figma-22-px': '1.375rem',
      '--figma-13-px': '0.8125rem'
    }
  }, _defineProperty(_ref3, theme.breakpoints.down('sm'), {
    display: 'none'
  }), _defineProperty(_ref3, '.MuiGrid-item', {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    flexWrap: 'nowrap',
    '&:not(:last-of-type)::after': {
      content: '"|"',
      color: theme.palette.grey['400'],
      fontSize: 'var(--figma-13-px)',
      marginLeft: 'var(--figma-22-px)',
      marginRight: 'var(--figma-22-px)'
    }
  }), _ref3;
});

var DesktopFooterItems = function DesktopFooterItems() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(StyledGrid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "font.tertiary",
    variant: "body2"
  }, "\xA9 2022 Attuned")), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(StyledLink, {
    target: "_blank",
    href: t('URL_privacy_policy'),
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2"
  }, t('privacy')))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(StyledLink, {
    target: "_blank",
    href: t('URL_terms'),
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2"
  }, t('terms')))));
};

var _default = DesktopFooterItems;
exports.default = _default;